import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { publicApi, useApi, getToken, setToken } from "@/lib/api";

const SiteCtx = createContext({ settings: null, reload: () => {} });
const MeCtx = createContext({ me: null, loading: true, reloadMe: () => {}, signIn: () => {}, signOut: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(() => publicApi.get("/settings").then((r) => setSettings(r.data)), []);
  useEffect(() => {
    reload();
  }, [reload]);
  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement.style;
    if (settings.accent_primary) root.setProperty("--copper", settings.accent_primary);
    if (settings.accent_secondary) root.setProperty("--gold", settings.accent_secondary);
  }, [settings]);
  return <SiteCtx.Provider value={{ settings, reload }}>{children}</SiteCtx.Provider>;
}

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const reloadMe = useCallback(async () => {
    if (!getToken()) {
      setMe(null);
      setLoading(false);
      return;
    }
    try {
      setMe(await api("get", "/me"));
    } catch (e) {
      if (e?.response?.status === 401) setToken(null);
      setMe(null);
    } finally {
      setLoading(false);
    }
  }, [api]);
  useEffect(() => {
    reloadMe();
  }, [reloadMe]);
  const signIn = useCallback((token, user) => {
    setToken(token);
    setMe(user);
  }, []);
  const signOut = useCallback(() => {
    setToken(null);
    setMe(null);
  }, []);
  return <MeCtx.Provider value={{ me, loading, reloadMe, signIn, signOut }}>{children}</MeCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
export const useMe = () => useContext(MeCtx);

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | أكاديمية هِمّة تم` : "أكاديمية هِمّة تم";
  }, [title]);
}
